import { render, staticRenderFns } from "./AddPostProduction.vue?vue&type=template&id=4ca9abb0"
import script from "./AddPostProduction.vue?vue&type=script&lang=js"
export * from "./AddPostProduction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports